import { render, staticRenderFns } from "./postmark.vue?vue&type=template&id=cb196cec&scoped=true&"
import script from "./postmark.vue?vue&type=script&lang=js&"
export * from "./postmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb196cec",
  null
  
)

export default component.exports